import React, {Component} from 'react';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import UserDelete from "./UserDelete";


class UserDeletePage extends React.Component {
    constructor(props) {
        super(props);
    }

    render() {
        if(this.props.user.id === undefined) {
            return null;
        }
        return (
            <UserDelete userId={this.props.user.id} />
        )

    }
}

function mapStateToProps(state) {
    return {
        user: state.user,
    };
}

export default connect(mapStateToProps)(UserDeletePage);









// WEBPACK FOOTER //
// ./web/src/components/users/UserDeletePage.jsx